import { z } from 'zod';
export const ESupportedISOCountryIDs = Object.freeze({
    BRAZIL: 'BR',
});
export const ISOCountryVO = z
    .string()
    .length(2)
    .regex(/^[A-Z]+$/);
export const ISOSubdivisionVO = z
    .string()
    .min(4)
    .max(13)
    .regex(/^[A-Z]{2}-[A-Z0-9]{1,10}$/);
//# sourceMappingURL=iso.js.map